// extracted by mini-css-extract-plugin
export default {"container":"TemplateActions_container__p84lO"};